export const TOASTS_TYPES = {
	SUCCESS: 'success',
	ERROR: 'error',
	WARNING: 'warning'
}
